<!--<div bsModal #apptModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-event-name">-->
@if (this.viewType != 'changeAssignee') {
  <div class="modal-dialog modal-lg">
    @if (selectedAppt) {
      <div class="modal-content border-0">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 id="dialog-event-name" class="modal-title text-white fs-18">{{submitTrainingViewTitle()}}</h4>
          <img src="assets/images/icons/white-cross.svg" alt="" (click)="hideTrainingModal()" class="cursor hw-24">
        </div>
        <form (ngSubmit)="addUpdateTraining()">
          <div class="modal-body">
            <div>
              @if (selectedAppt.viewType !== 'newTraining') {
                <div class="form-group">
                  <h4>Trainee Details: {{selectedAppt.training_doctor_partner_type == 'doctor' ? 'Business' :
                  selectedAppt.training_doctor_partner_type}}{{selectedAppt.doctor_partner_type}} </h4>
                  @if (selectedAppt.training_doctor_partner_type == 'doctor') {
                    <div class="row">
                      <div class="col-4">
                        Booked For:<b class="ml-1"> Business</b>
                      </div>
                      <div class="col-4">Name:
                        @if (selectedAppt.selectedDoctorId!==0) {
                          <span class="text-muted">
                            <b class="ml-1"><a [routerLink]="'/app/business/details/'+selectedAppt.selectedDoctorId"
                            (click)="hideTrainingModal()">{{selectedAppt.selectedDoctor.doctor_name}}</a></b>
                          </span>
                        }
                        @if (selectedAppt.selectedDoctorId===0) {
                          <span><b
                          class="ml-1">{{selectedAppt.selectedDoctor.doctor_name}}</b></span>
                        }
                      </div>
                      <div class="col-4">Email:
                        <b class="ml-1" style="word-break: break-all">{{selectedAppt.selectedDoctor.doctor_emails}}</b>
                      </div>
                      <div class="col-4">
                        Business Name:<b
                      class="ml-1">{{selectedAppt.selectedDoctor.practice_name?selectedAppt.selectedDoctor.practice_name:'N.A.'}}</b>
                    </div>
                    <div class="col-4">
                      Phone:<b class="ml-1">
                      {{selectedAppt.selectedDoctor.practice_mobile?(selectedAppt.selectedDoctor.practice_mobile | phoneFormat):'N.A.'}}
                    </b>
                  </div>
                </div>
              }
              @if (selectedAppt.training_doctor_partner_type == 'partner') {
                <div class="row">
                  <div class="col-4">
                    Booked For:<b class="ml-1"> Partner</b>
                  </div>
                  <div class="col-4">Name:
                    @if (selectedAppt.selectedDoctorId!==0) {
                      <span class="text-muted">
                        <b class="ml-1"><a [routerLink]="'/app/partners/profile/'+selectedAppt.selectedDoctorId"
                          (click)="hideTrainingModal()">
                        {{selectedAppt.selectedDoctor.partner_name || selectedAppt.selectedDoctor.doctor_name}}</a></b>
                      </span>
                    }
                    @if (selectedAppt.selectedDoctorId===0) {
                      <span><b
                      class="ml-1">{{selectedAppt.selectedDoctor.doctor_name}}</b></span>
                    }
                  </div>
                  <div class="col-4">Email:
                    <b class="ml-1" style="word-break: break-all">{{selectedAppt.selectedDoctor.partner_email ||
                    selectedAppt.selectedDoctor.doctor_emails}}</b>
                  </div>
                  <div class="col-4">
                    Phone:<b class="ml-1">
                    {{selectedAppt.selectedDoctor.partner_mobile?(selectedAppt.selectedDoctor.partner_mobile | phoneFormat ):selectedAppt.selectedDoctor.practice_mobile?(selectedAppt.selectedDoctor.practice_mobile | phoneFormat):'N.A.'}}
                  </b>
                </div>
              </div>
            }
            <br /><br />
            <h4>Training Info: </h4>
            <div class="row">
              <div class="col-4">
                Schedule
                Date:<b class="ml-1">{{selectedAppt.schedule_date}}</b>
              </div>
              <div class="col-4">
                Schedule Time:<b class="ml-1">{{selectedAppt.schedule_time}}</b>
              </div>
              <!--<div class="col-4">
              Timezone:<b class="ml-1">{{selectedAppt.offset}}</b>
            </div>-->
            <div class="col-4">
              Duration:<b class="ml-1">{{selectedAppt.training_duration + ' mins'}}</b>
            </div>
            <div class="col-4">
              Type of Training:
              <b class="ml-1">{{selectedAppt.selectedTrainingObj ? selectedAppt.selectedTrainingObj.name : ''}}</b>
            </div>
            <div class="col-4">
              Assigned to:
              <b class="ml-1">{{selectedAppt.excludeAdmin && (selectedAppt.excludeAdmin.admin_name + '
              ('+selectedAppt.excludeAdmin.admin_email+')')}}</b>
            </div>
            <div class="col-4">
              Status:
              <b class="ml-1">{{selectedAppt.training_status_name}}</b>
            </div>
            @if (selectedAppt.eventId) {
              <div class="col-4">
                <a class="pointer" [routerLink]="'/app/training/details/'+ selectedAppt.eventId"
                  (click)="hideTrainingModal()">
                  View All Details
                </a>
              </div>
            }
            <!--<div class="col-4">
            <a class="pointer" [routerLink]="'/app/training/details/'+ selectedAppt.eventId"training_id">
              View All Details
            </a>
          </div>-->
        </div>
      </div>
    }
    @if (selectedAppt.viewType === 'newTraining') {
      <div class="d-flex align-items-center">
        <label class="past-training me-2">Do you want to book past training ?</label>
        <div class="switch">
          <label>
            <input class="form-control" type="checkbox" [(ngModel)]="trainingSwitch" name="trainingSwitch">
            <span class="lever m-0"></span>
          </label>
        </div>
      </div>
    }
    <hr>
      <div class="row d-flex align-items-center mb-2">
        @if (!trainingSwitch && (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining')) {
          <div class="col-4"
            >
            <div class="form-group">
              <label>Schedule Date : </label>
              <input class="input_field datepicker_field py-2" name="aptDate" [(ngModel)]="selectedAppt.date" bsDatepicker
                (ngModelChange)="trainingDateChanged()" [minDate]="getMinDate()" type='text' readonly
                (keydown)="disableKeyDown($event)" [bsConfig]="{  containerClass: 'theme-blue' }" />
              </div>
            </div>
          }
          @if (trainingSwitch) {
            <div class="col-4">
              <div class="form-group">
                <label>Schedule Date : </label>
                <input class="input_field datepicker_field py-2" name="selectedAppt.date" [(ngModel)]="selectedAppt.date"
                  bsDatepicker [maxDate]="getPastMinDate()" type='text' readonly
                  [bsConfig]="{  containerClass: 'theme-blue' }" />
                </div>
              </div>
            }
            <!--<div class="col-4">
            <label for="">Time*</label>
            <timepicker required [(ngModel)]="selectedAppt.time" #aptTime="ngModel" name="aptTime"></timepicker>
          </div>-->
          @if (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining') {
            <div class="col-4"
              >
              <div class="form-group">
                <label for="">Type of Training*</label>
                <div class="input_field py-0">
                  <select required class="input_field selectType m-0 px-0 border-0" [(ngModel)]="selectedAppt.selectedTraining" name="aptTraining"
                    (change)="onTrainingSelect()">
                    @for (type of selectedAppt.trainingTypes; track type) {
                      <option [value]="type.type_id">{{type.name}}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          }
          <!-- <div class="w-100"></div> -->
          @if (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining') {
            <div class="col-4 form-group"
              >
              <label for="timezone">Timezone*</label>
              <div class="input_field py-0">
                <select name="aptTimezone" class="input_field selectType m-0 px-0 border-0" [(ngModel)]="selectedAppt.timezone"
                  (change)="trainingTimezoneChanged()">
                  @for (timezone of timezones; track timezone) {
                    <option [value]="timezone.code+'****'+timezone.tzOffset">
                    {{timezone.name}} (GMT{{timezone.timezoneString}})</option>
                  }
                </select>
              </div>
            </div>
          }
          @if (!trainingSwitch && (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining')) {
            <div class="col-4 form-group"
              >
              <label for="timezone">Training Duration*</label>
              <div class="input_field py-0">
                <select name="aptDuration" class="input_field selectType m-0 px-0 border-0" [(ngModel)]="selectedAppt.trainingDuration"
                  (change)="trainingDurationChanged()">
                  @for (trainingDuration of trainingDurations; track trainingDuration) {
                    <option [value]="trainingDuration">
                    {{trainingDuration}} Minutes</option>
                  }
                </select>
              </div>
            </div>
          }
          @if (trainingSwitch && (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining')) {
            <div class="col-4 form-group"
              >
              <label for="timezone">Training Duration*</label>
              <div class="input_field py-0">
                <select name="aptDuration" class="input_field selectType m-0 px-0 border-0" [(ngModel)]="selectedAppt.trainingDuration">
                  @for (trainingDuration of trainingDurations; track trainingDuration) {
                    <option [value]="trainingDuration">
                    {{trainingDuration}} Minutes</option>
                  }
                </select>
              </div>
            </div>
          }
          @if (selectedAppt.viewType !== 'updateTrainingNotes' && selectedAppt.viewType !== 'newTraining') {
            <div class="col-4 form-group"
              >
              <label for="status">Status*</label>
              <div class="input_field py-0">
                <select name="aptStatus" [(ngModel)]="selectedAppt.status" id="status" class="input_field selectType m-0 px-0 border-0"
                  (change)="trainingStatusChanged()">
                  <!--<option value="1">New Registration</option>-->
                  @for (trainingStatus of trainingStatusTypes; track trainingStatus) {
                    @if (shouldShowOption(trainingStatus.training_status_id, selectedAppt)) {
                      <option
                        [value]="trainingStatus.training_status_id">{{trainingStatus &&
                      trainingStatus.training_status_name}}</option>
                    }
                  }
                </select>
              </div>
            </div>
          }
          @if (selectedAppt.viewType !== 'updateTrainingNotes' && selectedAppt.viewType !== 'newTraining' && (selectedAppt.status == 4 || selectedAppt.status == 9)) {
            <div class="col-4 form-group"
              >
              <label for="">Follow Up*</label>
              <div class="input-group">
                <input required [(ngModel)]="selectedAppt.followup_date" name="followupDate" class="form-control"
                  bsDatepicker readonly #dp="bsDatepicker" [bsConfig]="dateConfig" [minDate]="today"
                  style="background: #ffffff;" placeholder="Choose a date">
                  <div class="input-group-append">
                    <button type="button" (click)="dp.toggle()" class="btn rounded"><i
                    class="fa fa-calendar"></i></button>
                  </div>
                </div>
              </div>
            }
            @if (!trainingSwitch && (!selectedAppt.out_of_system || selectedAppt.viewType === 'editTraining')) {
              <div class="col-4 form-group checkbox c-checkbox mt-4 d-flex align-items-center"
                >
                <input class="secondary-checkbox" #sendEmail [(ngModel)]="selectedAppt.send_email" name="sendEmail"
                  type="checkbox" id="sendEmail">
                  <label class="fs-14 fw-400 m-0" for="sendEmail"></label>Send Email
                </div>
              }
            </div>
            <div class="w-100"></div>
            @if (!trainingSwitch && (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining')) {
              <div class="row align-items-center form-group mb-2"
                >
                <div class="col-12">Select Training Time*</div>
                @if (!selectedAppt.availableStartTimes.length) {
                  <div class="col-12 no_available_time_error">No slots
                  available for selected date.</div>
                }
                @for (availableStartTime of selectedAppt.availableStartTimes; track availableStartTime; let i = $index) {
                  <div class="col-2">
                    <button type="button" class="btn available_start_time"
                      [ngClass]="selectedAppt.selectedAvailableStartTime ? selectedAppt.selectedAvailableStartTime.timeAmPm ===  availableStartTime.timeAmPm ? 'btn-primary' : 'btn-outline-secondary' : 'btn-outline-secondary'"
                    (click)="selectTrainingTime(availableStartTime)">{{availableStartTime.timeAmPm}}</button>
                  </div>
                }
              </div>
            }
            @if (trainingSwitch) {
              <div class="row align-items-center form-group mb-2">
                <div class="col-12">Select Training Time*</div><br>
                <div class="col-6 past-hours mt-1">
                  <ngx-select [items]="hours" optionValueField="value" optionTextField="value" name="value"
                    [allowClear]="false" placeholder="HH" [(ngModel)]="pastTrainingTime.hour">
                    <ng-template ngx-select-option-selected let-option>
                      {{option.data.value}}
                    </ng-template>
                    <ng-template ngx-select-option-not-found>
                      Not found
                    </ng-template>
                  </ngx-select>
                </div>
                <div class="col-6 mt-1">
                  <ngx-select [items]="minutes" optionValueField="value" optionTextField="value" name="value"
                    [allowClear]="false" placeholder="MM" [(ngModel)]="pastTrainingTime.minutes">
                    <ng-template ngx-select-option-selected let-option>
                      {{option.data.value}}
                    </ng-template>
                    <ng-template ngx-select-option-not-found>
                      Not found
                    </ng-template>
                  </ngx-select>
                </div>
              </div>
            }
            @if (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining') {
              <div class="row align-items-center"
                >
                @if (selectedAppt.availableAdminUsers.length) {
                  <div class="col-4 form-group">
                    <div class="form-group">
                      <label>CSR Name*</label>
                      <ngx-select [items]="selectedAppt.availableAdminUsers" optionValueField="admin_id"
                        optionTextField="admin_name" [allowClear]="true" (select)="selectApptAdmin()"
                        (typed)="fetchAvailableAdminList($event)" name="selectedAdmin"
                        [(ngModel)]="selectedAppt.selectedAdminId" [placeholder]="'Select CSR'"
                        [disabled]="selectedAppt.assign_automatic">
                        <ng-template ngx-select-option-selected let-option>
                          {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
                        </ng-template>
                        <ng-template ngx-select-option let-option let-text="text">
                          {{option.data.admin_name}} <br>
                          <small>{{option.data.admin_email}}</small>
                        </ng-template>
                        <ng-template ngx-select-option-not-found>
                          Not found
                        </ng-template>
                      </ngx-select>
                    </div>
                  </div>
                }
                @if (selectedAppt.availableAdminUsers.length) {
                  <div class="mt-1 col-4 d-flex align-items-center">
                    <input class="secondary-checkbox" #assign_automatic [(ngModel)]="selectedAppt.assign_automatic"
                      name="assign_automatic" type="checkbox" (ngModelChange)="assignAutomaticChanged()"
                      id="assign_automatic" />
                      <label class="fs-14 fw-400 m-0" for="assign_automatic"></label>Assign Automatically
                    </div>
                  }
                </div>
              }
              <div class="w-100"></div>
              @if (selectedAppt.viewType === 'newTraining') {
                <div class="row align-items-center form-group">
                  <div class="col-8 mt-3">
                    <label class="mb-2 mt-2">Book Training For</label>
                    <div>
                      <span class="d-flex align-items-center">
                        <input class="secondary-radio" checked="checked"
                          [(ngModel)]="selectedAppt.training_doctor_partner_type" (ngModelChange)="resetTraineeSelection()"
                          name="training_doctor_partner_type" type="radio" value="doctor" id="training_doctor_partner_type">
                          <label class="fs-14 fw-400 m-0" for="training_doctor_partner_type">Business</label>
                          <!-- <span class="mt-2">Business</span> -->
                        </span>
                        <!-- <span>
                        <input class="secondary-radio" name="training_doctor_partner_type"
                          [(ngModel)]="selectedAppt.training_doctor_partner_type" type="radio" value="partner"
                          (ngModelChange)="resetTraineeSelection()" id="training_doctor_partner_type">
                          <label class="fs-14 fw-400 m-0" for="training_doctor_partner_type"></label>Partner
                        </span> -->
                      </div>
                    </div>
                    <div class="w-100"></div>
                    @if (!trainingSwitch && !selectedAppt.selectedDoctorId) {
                      <div class="col-4">
                        <div class="mt-1">
                          <span class="d-flex align-items-center mb-2">
                            <input class="secondary-checkbox" #out_of_system [(ngModel)]="selectedAppt.out_of_system"
                              name="out_of_system" type="checkbox" (ngModelChange)="outOfSystemChanged()" id="out_of_system" />
                              <label class="fs-14 fw-400 m-0" for="out_of_system"></label>
                  <span style="
                      display: inline-block; 
                  " class="fs-14 fw-400 m-0">Unregistered </span>
                              <i
                                class="fa fa-info-circle" data-container="body" data-placement="top"
                    tooltip="Please select this option to schedule training for unregistered Business" style="
                    display: block;
                    margin-left: 8px;"></i>
                            </span>
                          </div>
                        </div>
                      }
                      <div class="w-100"></div>
                      @if (!selectedAppt.out_of_system) {
                        <div class="col-12 pl-0">
                          @if (selectedAppt.training_doctor_partner_type == 'doctor') {
                            <div class="col-6">
                              <div class="form-group">
                                <label class="mt-2">Business Name*</label>
                                <ngx-select [items]="selectedAppt.doctors" optionValueField="doctor_id" optionTextField="doctor_name"
                                  [allowClear]="false" (select)="selectTrainingDoctor($event)" (typed)="fetchDoctorList($event)"
                                  name="trainingSelectedDoctor" [(ngModel)]="selectedAppt.selectedDoctorId" readonly>
                                  <ng-template ngx-select-option-selected let-option>
                                    {{option.data.practice_name?option.data.practice_name:'-'}}
                                  </ng-template>
                                  <ng-template ngx-select-option let-option let-text="text">
                                    <div class="ngx-option-content">
                                      <h5 class="m-0">{{option.data.doctor_name}}</h5>
                                      <small class="m-0">
                                        Business: {{option.data.practice_name}} | Email: {{option.data.doctor_email}}
                                      </small>
                                    </div>
                                  </ng-template>
                                  <ng-template ngx-select-option-not-found>
                                    Not found
                                  </ng-template>
                                </ngx-select>
                              </div>
                            </div>
                          }
                          @if (selectedAppt.training_doctor_partner_type == 'partner') {
                            <div class="col-6">
                              <div class="form-group">
                                <label>Partner Name*</label>
                                <ngx-select [items]="selectedAppt.doctors" optionValueField="partner_id"
                                  optionTextField="partner_name" [allowClear]="false" (select)="selectTrainingDoctor($event)"
                                  (typed)="fetchDoctorList($event)" name="trainingSelectedDoctor"
                                  [(ngModel)]="selectedAppt.selectedDoctorId" readonly>
                                  <ng-template ngx-select-option-selected let-option>
                                    {{option.data.partner_name?option.data.partner_name:'-'}}
                                  </ng-template>
                                  <ng-template ngx-select-option let-option let-text="text">
                                    <h5 class="m-0">{{option.data.partner_name}}</h5>
                                    <small class="m-0">
                                      {{option.data.partner_email}}
                                    </small>
                                  </ng-template>
                                  <ng-template ngx-select-option-not-found>
                                    Not found
                                  </ng-template>
                                </ngx-select>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      <div class="d-flex">
                        @if (selectedAppt.out_of_system && selectedAppt.training_doctor_partner_type == 'doctor') {
                          <div class="col-6 me-2">
                            <div class="form-group">
                              <label class="mt-2">Business Name</label>
                              <input type="text" class="form-control" [(ngModel)]="selectedAppt.selectedDoctor.practice_name" practice
                                name="aptPracticeName">
                                @if (selectedAppt.out_of_system && (selectedAppt.selectedDoctor.practice_name ? selectedAppt.selectedDoctor.practice_name.length > 256 : false)) {
                                  <p class="text-danger mb-0"
                                    >
                                    Please enter valid Business name.
                                  </p>
                                }
                              </div>
                            </div>
                          }
                          <!--<span *ngIf="!selectedAppt.out_of_system && selectedAppt.selectedDoctor ">-->
                          @if ((!selectedAppt.out_of_system && selectedAppt.selectedDoctor) || selectedAppt.out_of_system) {
                            <div class="col-6"
                              >
                              <div class="form-group">
                                <label class="mt-2" for="">Contact Name*</label>
                                <input [disabled]="!selectedAppt.out_of_system" type="text" class="form-control" contact
                                  [(ngModel)]="selectedAppt.selectedDoctor.doctor_name" name="aptContactName" trim="true">
                                  @if (selectedAppt.out_of_system && (!selectedAppt.selectedDoctor.doctor_name || selectedAppt.selectedDoctor.doctor_name.length > 256)) {
                                    <p class="text-danger mb-0"
                                      >
                                      Please enter valid contact name.
                                    </p>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                          <div class="d-flex mt-2 ">
                            @if ((!selectedAppt.out_of_system && selectedAppt.selectedDoctor) || selectedAppt.out_of_system) {
                              <div class="col-6 me-2">
                                <div class="form-group">
                                  <label for="">Phone Number</label>
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <select name="mobile_code" class="input-group-text p-1" style="height: 38px; border-bottom-right-radius: 0; border-top-right-radius: 0;" [(ngModel)]="selectedMobileCode"
                                        (change)="changeMobileCode(selectedMobileCode)">
                                        @for (option of mobile_code_arr; track option; let i = $index) {
                                          <option [value]="option">
                                            <span>{{option}}</span>
                                          </option>
                                        }
                                      </select>
                                    </div>
                                    <input [disabled]="!selectedAppt.out_of_system" phone type="text" [mask]="mask" class="form-control"
                                      [(ngModel)]="selectedAppt.selectedDoctor.doctor_mobile" name="aptPhone" />
                                    </div>
                                    @if (selectedAppt.out_of_system && (selectedAppt.selectedDoctor.doctor_mobile ? !isPhoneNumberValid(selectedAppt.selectedDoctor.doctor_mobile) : false)) {
                                      <p class="text-danger mb-0"
                                        >
                                        Please enter a valid phone number.
                                      </p>
                                    }
                                  </div>
                                </div>
                              }
                              @if ((!selectedAppt.out_of_system && selectedAppt.selectedDoctor) || selectedAppt.out_of_system) {
                                <div class="col-6"
                                  >
                                  <div class="form-group">
                                    <label for="">Email Address*</label>
                                    <input [disabled]="!selectedAppt.out_of_system" type="text" email name="aptEmail" class="form-control"
                                      [(ngModel)]="selectedAppt.selectedDoctor.doctor_emails" />
                                      @if (selectedAppt.out_of_system && (!selectedAppt.selectedDoctor.doctor_emails || !isValidEmail(selectedAppt.selectedDoctor.doctor_emails))) {
                                        <p class="text-danger mb-0"
                                          >
                                          Please enter a valid email.
                                        </p>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            <!--</span>-->
                            <!--<div class ="col-12" *ngIf="selectedAppt.out_of_system">
                            <div class="form-group">
                              <label>Enter Email (Press enter to add):</label>
                              <input type="text" class="form-control" email [(ngModel)]="doctor_emails" #cEmail="ngModel" name="cEmail"
                                (keyup.enter)="addEmails($event,addAppointmentForm)" trim="blur" />
                                <p class="text-danger" *ngIf="cEmail.invalid && (cEmail.dirty || cEmail.touched)">Please enter a valid email.
                                </p>
                              </div>
                              <div>
                                <label *ngIf="doctorEmails && doctorEmails.length > 0">Selected Emails: </label>
                                <h3>
                                  <span class="ml-1 badge text-large badge-primary" *ngFor="let email of doctorEmails">{{email}}
                                    &nbsp;<i class="fa fa-close" tappable (click)="removeEmail(email)"></i>
                                  </span>
                                </h3>
                                <label *ngIf="!doctorEmails || doctorEmails.length == 0">No Email added yet</label>
                              </div>
                            </div>-->
                          </div>
                        }
                        @if (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining') {
                          <div class="row align-items-center form-group"
                            >
                            <div class="col-6">
                              <div class="form-group">
                                <label class="mt-2 d-flex align-items-center gap-3" for="">Meeting Link <span class="info-wrapper ml-2">
                                  <i class="fa fa-info-circle"></i>
                                  <span class="info-text">
                                    Leave this field empty to use an auto-generated meeting link in the invite.
                                    If you add a link here, the invite will use your link instead.
                                  </span>
                                </span></label>
                                <input type="text" name="aptMeetingLink" class="form-control"
                                  [(ngModel)]="selectedAppt.trainingMeetingLink" />
                                  @if ((selectedAppt.trainingMeetingLink && !isValidUrl(selectedAppt.trainingMeetingLink))) {
                                    <p class="text-danger"
                                      >Please
                                      enter a valid link.
                                    </p>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          <div class="row align-items-center">
                            <div class="col-12 form-group">
                              <label class="mt-2" for="note">Note*</label>
                              <textarea name="aptNote" required [(ngModel)]="selectedAppt.trainingNote" id="" cols="30" rows="4"
                              class="form-control"></textarea>
                            </div>
                          </div>
                          <!--<div class="row align-items-center">
                        </div>-->
                      </div>
                    </div>
                    <div class="modal-footer">
                      <div class="d-flex">
                        <div class="text-right">
                          <button type="submit" [disabled]="!enableDisableSubmitTrainingButton()"
                          class="btn btn-primary">{{submitTrainingButtonTitle()}}</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              }
            </div>
          }
        <!--</div>-->



        <!-- change changeAssignee modal -->
        @if (this.viewType === 'changeAssignee') {
          <div class="modal-dialog modal-lg">
            <div class="modal-content" style="border: none;">
              <div class="modal-header bg-primary d-flex justify-content-between">
                <h4 class="modal-title fs-20">Change Assignee</h4>
                <img src="assets/images/icons/white-cross.svg" alt="" class="cursor hw-24" aria-label="Close"
                  (click)="hideTrainingModal()">
                </div>
                <div class="modal-body">
                  <span class="fs-14 mb-2 fw-500">Select Support Agent</span>
                  @if (selectedAppt?.availableAdminUsers?.length) {
                    <div class="col-4 form-group">
                      <div class="form-group">
                        <!-- <label>CSR Name*</label> -->
                        <ngx-select [items]="selectedAppt.availableAdminUsers" optionValueField="admin_id"
                          optionTextField="admin_name" [allowClear]="true" (select)="selectApptAdmin()"
                          (typed)="fetchAvailableAdminList($event)" name="selectedAdmin" [(ngModel)]="selectedAppt.selectedAdminId"
                          [placeholder]="'Select CSR'" [disabled]="selectedAppt.assign_automatic">
                          <ng-template ngx-select-option-selected let-option>
                            {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
                          </ng-template>
                          <ng-template ngx-select-option let-option let-text="text">
                            {{option.data.admin_name}} <br>
                            <small>{{option.data.admin_email}}</small>
                          </ng-template>
                          <ng-template ngx-select-option-not-found>
                            Not found
                          </ng-template>
                        </ngx-select>
                      </div>
                    </div>
                  } @else {
                    <input type="text" class="form-control mb-2" placeholder="No support agent available" disabled>
                    <p class="text-danger fs-14 fw-500 mt-2">
                      No support agent is available for this time slot. You can edit or reschedule the training.
                    </p>
                  }
                  <div class="col-12 form-group mt-2">
                    <label for="note">Note*</label>
                    <textarea name="aptNote" required [ngModel]="$safeNavigationMigration(selectedAppt?.trainingNote)"
                    (ngModelChange)="selectedAppt.trainingNote = $event" id="" cols="30" rows="4" class="form-control"></textarea>
                  </div>
                </div>
                <div class="modal-footer">
                  @if (selectedAppt?.availableAdminUsers?.length) {
                    <button type="button" class="btn btn-primary" (click)="changeScheduledTrainingAssignee()"
                      [disabled]="!selectedAppt.selectedAdmin|| !selectedAppt?.trainingNote?.trim()">
                      Save
                    </button>
                  }
                  @if (!selectedAppt?.availableAdminUsers?.length) {
                    <button type="button" class="btn btn-primary" (click)="editAdmin()">
                      Edit
                    </button>
                  }
                  <button type="button" class="btn btn-secondary" (click)="hideTrainingModal()">Cancel</button>
                </div>
              </div>
            </div>
          }
